import React from "react"
import { Box, Skeleton } from "@mui/material"

import { dsColorNew } from "@palette"


// The shape of a table while its rows arrive: the navy header and a few grey rows, so nothing jumps when the data lands
export default function AppTableSkeleton({ rows = 5, columns = 4, sx = {} }) {
	return <Box aria-busy="true" sx={{ borderRadius: '10px', overflow: 'hidden', border: `1px solid ${dsColorNew.grayBorder}`, ...sx }}>
		<Box sx={{ height: 40, backgroundColor: dsColorNew.tableHead }}/>
		{Array.from({ length: rows }, (_, row) => <Box key={row} sx={{
			display: 'grid', gridTemplateColumns: `1.4fr repeat(${columns - 1}, 1fr)`, gap: 2, px: 2, py: 1.75,
			borderTop: row ? `1px solid ${dsColorNew.grayBorder}` : 0,
			backgroundColor: row % 2 ? dsColorNew.tableRowAlt : dsColorNew.white,
		}}>
			{Array.from({ length: columns }, (_, col) => <Skeleton key={col} variant="rounded" height={10} sx={{ borderRadius: '5px' }}/>)}
		</Box>)}
	</Box>
}

// While a page's results load: the white card of the result with a title bar and the table skeleton (or a chart block)
export function AppResultsSkeleton({ rows = 8, columns = 6, chart = false, height = 480, sx = {} }) {
	return <Box aria-busy="true" sx={{ backgroundColor: dsColorNew.white, border: `1px solid ${dsColorNew.grayBorder}`, borderRadius: '14px', p: 2, ...sx }}>
		<Box sx={{ display: 'flex', alignItems: 'center', gap: 1.25, mb: 2 }}>
			<Skeleton variant="rounded" width={32} height={32} sx={{ borderRadius: '8px' }}/>
			<Skeleton variant="rounded" width={180} height={14} sx={{ borderRadius: '5px' }}/>
		</Box>
		{chart
			? <Skeleton variant="rounded" height={height} sx={{ borderRadius: '10px' }}/>
			: <AppTableSkeleton rows={rows} columns={columns}/>}
	</Box>
}
